// extracted by mini-css-extract-plugin
export var inlineLink = "_4n-0";
export var inlineLinkButton = "_4n-1";